import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import * as resources from './locales';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en_US',
    keySeparator: ':',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring'],
      caches: [],
    },
    returnNull: false,
  });

export default i18n;
